var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"faq-container"},[_c('div',{staticClass:"faq-grid"},_vm._l((_vm.items),function(item,index){return _c('FAQAccordionItem',{key:index,attrs:{"question":_vm.$tdb(item.question),"answer":_vm.$tdb(item.answer)}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }